import React from 'react';
import { MetricUId } from '../../Metrics/constants';
import WidgetBodyWrapper from '../WidgetBodyWrapper';
import { getFormattedRate, getMetricDataFromArray } from '../../Metrics/utils';
import ChrMetric from '../../../generic/PageUI/Compound/Metric/ChrMetric';
import OverviewSubMetric from '../OverviewSubMetric';

const Body = (props) => {
  const { metrics } = props;
  const publishedOrUnpublishedUsers = getMetricDataFromArray(metrics, MetricUId.PUBLISHED_OR_UNPUBLISHED_USERS_WITH_ROLES);
  const returningUsers = getMetricDataFromArray(metrics, MetricUId.RETURNING_USERS_WITH_ROLES);
  const totalPublishedUsers = getMetricDataFromArray(metrics, MetricUId.TOTAL_PUBLISHED_USERS_WITH_ROLES);
  let publishedRate = getMetricDataFromArray(metrics, MetricUId.PUBLISHED_RATE_WITH_ROLES);
  const formattedPublishedRate = getFormattedRate(publishedRate, { numeratorExtractorKey: "published" });
  const metricProps = {
    className: 'cui-border-gray border-radius-0-5-important p-3 d-flex align-items-center cui-management-report-temp-overview-metric',
    subMetricComponent: OverviewSubMetric,
    subMetricContainerClass: "justify-content-center flex-wrap"
  }

  return (
    <WidgetBodyWrapper { ...props } >
      <ChrMetric { ...metricProps } { ...publishedOrUnpublishedUsers } />
      {returningUsers && <ChrMetric { ...metricProps } { ...returningUsers } />}
      <ChrMetric { ...metricProps } { ...totalPublishedUsers } />
      <ChrMetric { ...metricProps } { ...formattedPublishedRate } />
    </WidgetBodyWrapper>
  );
};

export default Body;